export enum PatientType {
  Chronic = 'chronic',
  Acute = 'acute',
  Null = ""
}
export enum SearchBy {
  Kroll = 'kroll',
  Local = 'local',
}
export enum OrderType {
  Active = 'active',
  Past = 'past',
}

export enum RequestedOrderType {
  Active = 'active',
  Archived = 'archived',
}

export enum OrderStatus {
  All = 'All',
  WaitingForPayment = 'Waiting for Payment',
  ReadyToShip = 'Ready to Ship',
  PaidAndReadyToShip = 'Paid and Ready to Ship',
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  NoDues = 'No Dues',
}

export type PaginationKRoll = {
  page: number,
  per_page: number,
  shipping_type: PatientType.Chronic | PatientType.Acute | PatientType.Null,
  search_value: string[],
  server_location: number,
  sort_type: 'asc' | 'desc' | "",
  sort_key: string,
  search_by: SearchBy.Kroll | SearchBy.Local,
  order_status?: number[],
  order_type?: OrderType | "",
  requested_order_type?: RequestedOrderType | "",
  orders: "sale" | "processed",
  delivery_partner?: number,
  start_date?: string,
  end_date?: string,
  search?: string,
  create_pagination?: 1 | 0,
  user_visit_id?: any,
  searchKrollid?: string,
  status?:string[]
}

export type KrollCheckQuantity = {
  InventoryTypeID: number;
  SalesOrderID: number;
  Quantity: number;
  ShipType: string;
  StateID: number;
}

export enum MenuType {
  Sale = 'sale',
  Processed = 'processed'
}

const tenant = localStorage.getItem('tenant');

export const NotifyUsersBy = (() => {
  switch (tenant) {
    case 'sl':
    case 'qc':
      return [
        // { id: 1, value: 'Push', isChecked: true, disable: true },
        // { id: 3, value: 'Email', isChecked: true, disable: false }
        { id: 1, value: 'Push', isChecked: true },
        { id: 3, value: 'Email', isChecked: true },
        { id: 2, value: 'Chat message', isChecked: true }
      ];
    case 'wylo':
      return [
        { id: 3, value: 'Email', isChecked: true, disable: false }
      ];
    default:
      return [
        // { id: 1, value: 'Push', isChecked: false },
        // { id: 2, value: 'SMS', isChecked: false },
        // { id: 3, value: 'Email', isChecked: false }
        { id: 1, value: 'Push', isChecked: true },
        { id: 3, value: 'Email', isChecked: true },
        { id: 2, value: 'Chat message', isChecked: true }
      ];
  }
})();

// export const NotifyUsersBy = localStorage.getItem('tenant') == 'sl' ? [
//   { id: 1, value: 'Push', isChecked: true, disable: true },
//   { id: 3, value: 'Email', isChecked: true, disable: false }
// ] : [
//   { id: 1, value: 'Push', isChecked: false },
//   { id: 2, value: 'SMS', isChecked: false },
//   { id: 3, value: 'Email', isChecked: false }
// ]
export const NotifySlUsersBy = [
  { id: 1, value: 'Push', isChecked: true },
  { id: 3, value: 'Email', isChecked: true },
  { id: 2, value: 'Chat message', isChecked: true }
]

export const NotifyappointUsersBy = [
  { id: 1, value: 'Push', isChecked: true },
  { id: 3, value: 'Email', isChecked: true },
  { id: 2, value: 'Chat message', isChecked: true }
]
export const NotifyDeleteUser = [
  { id: 1, value: 'Delete Account', isChecked: true },
  { id: 3, value: 'Email', isChecked: true },
]

export type RequestedOrderPagination = {
  page: number,
  per_page: number,
  sort_type: 'asc' | 'desc' | "",
  sort_key: string,
  requested_order_type?: RequestedOrderType | "",
  /** 1 = Refill, 2 = Renewal — sent to batch_renew_refill index */
  requested_type?: 1 | 2,
  search?: string,
  create_pagination?: 1 | 0,
  searchKrollid?: string,
  status?: string[],
  server_location?: number
}
